import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hacker-news': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32V480H448V32H0zM21.2 229.2H21C21.1 229.1 21.2 228.9 21.3 228.8 21.3 228.9 21.3 229.1 21.2 229.2zM239.2 283.1V384H207.8V281.3L128 128H165.3C217.8 226.3 214.5 229.2 224.6 253.6 236.9 226.6 230.4 229.2 285.2 128H320L239.2 283.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hacker-news.js
// module id = uAXt
// module chunks = 144